import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function usePandaDocConfig(): {
  redirectToSupport: boolean;
  useFallbackUrl: boolean;
} {
  const { redirectToSupport, useFallbackUrl } = useCbhFlag(CbhFeatureFlag.PANDADOC_CONFIG, {
    defaultValue: { redirectToSupport: false, useFallbackUrl: false },
  });

  return { redirectToSupport: redirectToSupport ?? false, useFallbackUrl: useFallbackUrl ?? false };
}
